import axios from "axios";
import ProfileCardInterface from "@/common/types/ProfileCardInterface";
import { GroupAdditionalOption } from "../types/AdditionalOption";


export default {
    async searchProfiles(body): Promise<ProfileCardInterface[]> {
        return (await axios.post('/api/search-profiles', body)).data
    },

    async getAdditionalOptions(): Promise<GroupAdditionalOption[]> {
      return (await axios.get('/api/search/additional-options')).data
    }
}